import { date, uid } from "quasar"
import { CardNotificationEvent } from "src/util/enums/notifications"
import { getRandomID, getRandomInt, getTimeOfEvent } from "src/util/functions/randomData"
import { SystemNotificationCardData, UserNotificationCardData } from "src/util/types/notifications"
import { Config, names, starWars, uniqueNamesGenerator } from "unique-names-generator"

const mockUserNotifications: UserNotificationCardData[] = []
const mockSystemNotifications: SystemNotificationCardData[] = []

const config: Config = {
  dictionaries: [names, starWars],
  separator: " ",
}

// Object.keys() returns an array of both keys and values, hence divide its length by 2
const eventsInTotal = Object.keys(CardNotificationEvent).length / 2

function addPredefinedData() {
  mockUserNotifications.push(
    {
      id: uid(),
      triggeringUser: uniqueNamesGenerator(config),
      timeSinceReceived: getTimeOfEvent("today"),
      eventName: getRandomInt(eventsInTotal),
      relationId: "GS-R-2021-002",
      relationRepresentation: "Clean up Cellar Deck",
      hasItem: true,
      hasIssue: true,
      priority: getRandomInt(3, 1),
      isRead: false,
      isSystemCardNotification: false,
    },
    {
      // This notification should not appear, cuz it's older than 90 days
      id: uid(),
      triggeringUser: "Invisible Notification",
      timeSinceReceived: getTimeOfEvent("old"),
      eventName: getRandomInt(eventsInTotal),
      relationId: "GS-R-2021-002",
      relationRepresentation: "Clean up Cellar Deck",
      hasItem: false,
      hasWorkOrder: true,
      priority: getRandomInt(3, 1),
      isRead: false,
      isSystemCardNotification: false,
    },
    {
      // This notification should not appear, cuz it's older than 90 days
      id: uid(),
      triggeringUser: "Invisible Notification",
      timeSinceReceived: getTimeOfEvent("old"),
      eventName: getRandomInt(eventsInTotal),
      relationId: "1278-15-10-45",
      relationRepresentation: "Out of toilet paper",
      hasItem: true,
      hasIssue: true,
      priority: getRandomInt(3, 1),
      isRead: false,
      isSystemCardNotification: false,
    },
    {
      id: uid(),
      triggeringUser: uniqueNamesGenerator(config),
      timeSinceReceived: getTimeOfEvent("recent"),
      eventName: getRandomInt(eventsInTotal),
      relationId: "1278-15-10-45",
      relationRepresentation: "ElE-R-2023-002",
      hasItem: false,
      isRead: false,
      isSystemCardNotification: false,
    }
  )
}

function addExtraMockData() {
  for (let i = 0; i <= 5; i++) {
    const id = uid()
    const triggeringUser = uniqueNamesGenerator(config)
    const hasItem = Math.random() < 0.5
    const hasIssue = Math.random() < 0.5
    const hasWorkOrder = Math.random() < 0.5
    const isRead = Math.random() < 0.5
    const priority = hasIssue || hasWorkOrder ? getRandomInt(3, 1) : undefined

    const notificationData: UserNotificationCardData = {
      id,
      triggeringUser,
      timeSinceReceived: getTimeOfEvent("random"),
      eventName: getRandomInt(eventsInTotal),
      relationId: getRandomID(10),
      relationRepresentation: getRandomID(11),
      hasItem,
      hasIssue,
      hasWorkOrder,
      priority,
      isRead,
      isSystemCardNotification: false,
    }
    mockUserNotifications.push(notificationData)
  }
}

function addMockSystemNotificationData() {
  const dateInThePast = date.subtractFromDate(new Date(), { days: getRandomInt(20, 2) })
  // Make the minutes divisible by 5 (so that we don't see weird cases like fx. 11:18)
  const startTime = date.adjustDate(dateInThePast, {
    minutes: getRandomInt(11, 1) * 5,
  })

  const endTime = date.addToDate(startTime, { minutes: getRandomInt(11, 1) * 5 })

  // This notification should not appear, cuz its end time is in the past
  mockSystemNotifications.push({
    id: uid(),
    timeSinceReceived: getTimeOfEvent("recent"),
    startTime,
    endTime,
    isRead: false,
    isSystemCardNotification: true,
  })

  for (let i = 0; i <= 5; i++) {
    const dateInTheFuture = date.addToDate(new Date(), { days: getRandomInt(60, 1) })
    // Make the minutes divisible by 5 (so that we don't see weird cases like fx. 11:18)
    const startTime = date.adjustDate(dateInTheFuture, {
      minutes: getRandomInt(11, 1) * 5,
    })

    const endTime = date.addToDate(startTime, { minutes: getRandomInt(11, 1) * 5 })
    const isRead = Math.random() < 0.5

    const systemNotificationData: SystemNotificationCardData = {
      id: uid(),
      timeSinceReceived: getTimeOfEvent("random"),
      startTime: startTime,
      endTime: endTime,
      isRead,
      isSystemCardNotification: true,
    }
    mockSystemNotifications.push(systemNotificationData)
  }
}

export function getNotificationMockData() {
  const storedData = localStorage.getItem("mockNotifications")
  if (storedData) {
    return JSON.parse(storedData)
  } else {
    mockUserNotifications.length = 0
    mockSystemNotifications.length = 0

    // Fill up hard coded examples
    addPredefinedData()
    // Fill up dynamically generated examples
    addExtraMockData()
    // Fill up all system cards examples
    addMockSystemNotificationData()

    const allNotifications = [...mockUserNotifications, ...mockSystemNotifications]

    localStorage.setItem("mockNotifications", JSON.stringify(allNotifications))
    return allNotifications
  }
}
